import { store } from "../../store/configureStore";

export function userName() {
  const userName = localStorage.getItem("user_name");
  return userName.charAt(0).toUpperCase() + userName.slice(1);
}
export function isSubscriptionOverdue() {
  const currentPlan = localStorage.getItem("active_plan_name");
  const { currentSubscription } = store.getState().settings;
  let retry_count, overdue_reason;

  if (currentPlan !== "Basic" && currentSubscription) {
    retry_count = currentSubscription.retry_count;
    overdue_reason = currentSubscription.overdue_reason;
  }

  if (retry_count && overdue_reason) {
    return true;
  } else {
    return false;
  }
}

export const integratedStoreId = localStorage.getItem("integrated_store_id");



// WEBPACK FOOTER //
// ./src/newDropshipperApp/utils/user.js